var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pointer",style:({
        opacity: (_vm.loading)?0.5:1,
        'border-radius': '10%',
      }),on:{"click":_vm.onChange}},[(_vm.hooverModeEnable())?_c('hoover',{staticClass:"ma-1",staticStyle:{"vertical-align":"sub"},attrs:{"fill":_vm.isOk?'red':'#000000',"size":_vm.size}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }